import { useMemo } from 'react';
import { Banner } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@/constants/path';
import { tokenSelector } from '@/redux/features/auth.slice';
import { settingsSlice } from '@/redux/features/settings.slice';
import {
  dismissShipmentsBanner,
  makeShipmentsBannerDismissedSelector,
} from '@/redux/features/aiPromo.slice';
import BrandAvatar from '@/components/BrandAvatar';
import { StyledWorksWith, StyledAvatarStack } from './styled';

const ShipmentsAiBanner = () => {
  // Raw useSelector intentional per project convention (typed wrapper pulls axios ESM that breaks Jest)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useSelector(tokenSelector);
  const shop = (token?.shop as string) ?? '';
  const bannerDismissedSelector = useMemo(
    () => makeShipmentsBannerDismissedSelector(shop),
    [shop],
  );
  const isDismissed = useSelector(bannerDismissedSelector);

  if (isDismissed) return null;

  const handleConnect = () => {
    dispatch(settingsSlice.actions.handleSelected('aiAssistants'));
    navigate(PATH.SETTINGS);
  };

  return (
    <Banner
      title="Save time on shipment lookups"
      tone="info"
      action={{ content: 'Connect AI Assistant', onAction: handleConnect }}
      onDismiss={() => dispatch(dismissShipmentsBanner(shop))}
    >
      <p>
        Tip: ask your AI assistant{' '}
        <em>&quot;Which carrier has the worst on-time rate this week?&quot;</em>{' '}
        instead of building a report.
      </p>
      <StyledWorksWith>
        <StyledAvatarStack aria-hidden="true">
          <BrandAvatar brand="claude" size="sm" />
          <BrandAvatar brand="chatgpt" size="sm" />
          <BrandAvatar brand="perplexity" size="sm" />
          <BrandAvatar brand="grok" size="sm" />
        </StyledAvatarStack>
        <span>Works with Claude, ChatGPT, Perplexity, Grok, and more.</span>
      </StyledWorksWith>
    </Banner>
  );
};

export default ShipmentsAiBanner;
